<template>
  <div class="border-sm rounded-sm py-6">
    <BlockTitle
      title="Видеоотзывы представителей клиник"
      class="mb-6 px-6"
    />
    <CoreSwiper
      :slides-per-view="isMobile ? 1 : 2"
      :has-navigation="!isMobile"
    >
      <template #slides="{ slideAttrs }">
        <div
          v-for="lpuReview in lpuVideoReviews"
          :key="lpuReview.id"
          v-bind="slideAttrs"
        >
          <DoctorInfo
            :img-src="lpuReview.avatar_large.url"
            :fio="`${lpuReview.firstname} ${lpuReview.surname}`"
            :workplace="lpuReview.position"
            :lpu-review-id="lpuReview.id"
            class="pb-6 px-6 doctor-info"
          />
          <div
            class="position-relative"
            @click="openVideoDialog(lpuReview.rutube_link)"
          >
            <img
              alt="/"
              :src="lpuReview.video_preview.url"
              class="large-img"
              :class="{ 'elevation-1': !isMobile, 'mx-auto': isMobile }"
            >
            <button
              class="video-button"
              type="button"
            >
              <span class="video-button-item">
                <span class="ui-icon_reset primary--text ui-icon-player-play" />
              </span>
            </button>
          </div>
        </div>
      </template>
    </CoreSwiper>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import 'glightbox/dist/css/glightbox.min.css'
import { useContextStore } from 'src/store'
import DoctorInfo from 'src/components/pages/info/pressa/components/DoctorInfo.vue'
import BlockTitle from 'src/components/pages/info/pressa/components/BlockTitle.vue'
import CoreSwiper from 'src/core/CoreSwiper/CoreSwiper.vue'

type LpuVideoReview = {
  avatar_large: { url: string }
  firstname: string
  surname: string
  position: string
  video_preview: { url: string }
  video_id: string
  id: number
  rutube_link: string
}

defineProps<{
  lpuVideoReviews: LpuVideoReview[]
}>()

const lightboxInstance = ref<any>(null)

onMounted(async () => {
  const GLightbox = await import('glightbox')

  type LightboxType = ReturnType<typeof GLightbox.default>

  lightboxInstance.value = GLightbox.default({
    width: '900px',
    height: '506px',
    skin: 'clean-iframe-lightbox',
  }) as LightboxType
})

const { context } = useContextStore()
const isMobile = context.flavour === 'mobile'

const iframeHtml = (rutubeLink: string) => (`
      <iframe
        width="100%"
        height="99%"
        src="${rutubeLink}"
        frameborder="0"
        allowfullscreen
      ></iframe>
  `)

function openVideoDialog(rutubeLink: string) {
  if (!lightboxInstance.value) {
    return
  }

  lightboxInstance.value.setElements([{
    content: iframeHtml(rutubeLink),
    type: 'inline',
    width: isMobile ? '100vw' : '80vw',
    height: isMobile ? '30vh' : '80vh',
  }])

  lightboxInstance.value.open()
}

onUnmounted(() => {
  if (lightboxInstance.value) {
    lightboxInstance.value.destroy()
  }
})
</script>

<style scoped lang="scss">
@import 'www/themes/doctors/common/variables';

.large-img {
  max-width: 373px;
  height: 275px;
  object-fit: cover;
  display: block;
}

.video-button-item {
  z-index: 1;
  cursor: pointer;
  background-color: #ecf1fb;
  border-radius: 100%;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  display: flex;
  position: absolute;
  top: calc(50% - 20px);
  left: calc(50% - 20px);
}

.video-button {
    border: none;
    width: 100%;
    height: 100%;
    font-size: 66px;
    position: absolute;
    top: 0;
    left: 0;
}

.swiper-slide,
.swiper-slide * {
  box-sizing: border-box;
}
</style>

<style>
.glightbox-clean-iframe-lightbox .ginlined-content {
    padding: 0 !important;
    background: transparent !important;
    overflow: hidden !important;
}

.glightbox-clean-iframe-lightbox .ginlined-content iframe {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
}

.glightbox-clean-iframe-lightbox .gclose {
    position: absolute;
    border-radius: 4px !important;
    top: 10px !important;
    right: 20px !important;
    fill: #ffffff !important;
}
</style>
